/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import SettingsIcon from '@material-ui/icons/Settings';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

function SettingButton({
  updateOnClick,
  deleteOnClick,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <SettingsIcon
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
        // onMouseOver={handleClick}
      />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        // MenuListProps={{ onMouseLeave: handleClose }}
      >
        <MenuItem onClick={updateOnClick}>商城設定</MenuItem>
        {/* <MenuItem onClick={deleteOnClick}>刪除</MenuItem> */}
      </Menu>
    </div>
  );
}

SettingButton.propTypes = {
  updateOnClick: PropTypes.func,
  deleteOnClick: PropTypes.func,
};

SettingButton.defaultProps = {
  updateOnClick: () => {},
  deleteOnClick: () => {},
};

export default SettingButton;
